// extracted by mini-css-extract-plugin
export default {"message":"Message_message__2a2Un","content":"Message_content__EUs0P","media":"Message_media__cE1ll"};